import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import {CONNECT_STATUS} from '../../../../constants/profile';

const FeedPostStatus = props => {
  const {
    status,
    actions: { onConnect, onMessage, onApply },
  } = props;

  return (
    <>
      {
        {
          [CONNECT_STATUS.NOT_CONNECTED]: (
            <span className="feed-post-status" onClick={onConnect}>
              Connect
            </span>
          ),
          [CONNECT_STATUS.REQUIRE_APPROVE]: (
            <span className="feed-post-status feed-post-status--pending">
              Pending
            </span>
          ),
          [CONNECT_STATUS.CONNECTED]: (
            <span
              className="feed-post-status feed-post-status--message"
              onClick={onMessage}
            >
              Message
            </span>
          ),
          apply: (
            <span
              className="feed-post-status feed-post-status--apply"
              onClick={onApply}
            >
              Apply
            </span>
          ),
          applied: (
            <span className="feed-post-status feed-post-status--applied">
              Applied
            </span>
          ),
        }[status]
      }
    </>
  );
};

FeedPostStatus.proptTypes = {
  status: PropTypes.oneOf([
    ...Object.values(CONNECT_STATUS),
    'apply',
    'applied',
  ]).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
};

export default FeedPostStatus;
